import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';

import { AuthButton } from './components/AuthButton';
import { ChatWindow } from './components/ChatWindow';
import { AssetsPage } from './pages/AssetsPage';
import { MaintenanceLogPage } from './pages/MaintenanceLogPage';
import { FuelLogPage } from './pages/FuelLogPage';
import { ChatBubble } from './components/ChatBubble'; // <--- AÑADE ESTA LÍNEA

import './App.css';

function App() {
  // --- NUEVO ESTADO ---
  const [isChatOpen, setIsChatOpen] = useState(false);

  // --- NUEVA FUNCIÓN ---
  const toggleChat = () => {
    setIsChatOpen(prevState => !prevState);
  };

  return (
    <BrowserRouter>
      <Navbar bg="light" expand="lg" sticky="top">
        <Container>
          <Navbar.Brand as={Link} to="/">JIT data</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/assets">Gestión de Activos</Nav.Link>
              <Nav.Link as={Link} to="/maintenance">Registro Mantenimiento</Nav.Link>
              <Nav.Link as={Link} to="/fuel">Registro Combustible</Nav.Link>
            </Nav>
            <div className="ms-auto">
              <AuthButton />
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="main-content">
        <Routes>
          {/* <Route path="/" element={<ChatWindow />} /> <-- Quitado */}
          <Route path="/assets" element={<AssetsPage />} />
          <Route path="/maintenance" element={<MaintenanceLogPage />} />
          <Route path="/fuel" element={<FuelLogPage />} />
          {/* <Route path="*" element={<div>Página no encontrada</div>} /> */}
        </Routes>
      </div>

      {/* --- Burbuja flotante SIEMPRE visible --- */}
      {/* Asegúrate de tener el componente ChatBubble creado */}
      <ChatBubble onClick={toggleChat} />

      {/* --- Ventana de chat flotante SOLO si isChatOpen --- */}
      {isChatOpen && <ChatWindow handleClose={toggleChat} />}
    </BrowserRouter>
  );
}

export default App;
